import { useEffect } from 'react'
import { useRouter } from 'next/router'

import config from '@/config'
import useCurrentSession from '@/hooks/use-current-session'

const isDev = config.BUILD_ENV === 'dev'

const Brevo = () => {
  const router = useRouter()
  const session = useCurrentSession()
  const username = session.username
  const path = router.asPath

  useEffect(() => {
    if (typeof window === 'undefined' || isDev) return

    // Initialize Brevo SDK
    window.Brevo = window.Brevo || []

    // Initialize with client key and optional email for identify
    window.Brevo.push([
      'init',
      {
        client_key: 'vlt9q8ukk5edv078l553d1tl',
        ...(username && { email_id: username })
      }
    ])

    // Load the SDK script
    const scriptId = 'brevo-sdk-loader'
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script')
      script.id = scriptId
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://cdn.brevo.com/js/sdk-loader.js'
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    }

    // Track page view
    window.Brevo.push(['page'])

    return () => {
      if (typeof window === 'undefined') return
      // Cleanup script and iframes to prevent accumulation of duplicates
      document.getElementById(scriptId)?.remove()
      const iframes = document.querySelectorAll(
        `iframe[src^='https://sibautomation.com'], iframe[src^='https://cdn.brevo.com']`
      )
      iframes.forEach(iframe => {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe)
        }
      })
    }
  }, [username, path])
  return null
}

export default Brevo
